import { Button, Modal } from "@/atoms";
import { strings } from "@/constants";
import { ButtonVariantEnum } from "@/enums";
import type { ConfirmOptionsInterface } from "@/interfaces";

export const ConfirmDialog = ({
    isOpen,
    isPending = false,
    onCancel,
    onConfirm,
    options,
}: {
    isOpen: boolean,
    isPending?: boolean,
    onCancel: () => void,
    onConfirm: () => void,
    options: ConfirmOptionsInterface | null,
}) => {
    if (!options) return null;

    const {
        cancelLabel = strings.logoutModal.cancel,
        confirmLabel = strings.common.confirm,
        isDanger,
        message,
        title,
    } = options;

    const confirmVariant = isDanger ? ButtonVariantEnum.DANGER : ButtonVariantEnum.PRIMARY;

    return (
        <Modal
            isOpen={isOpen}
            onClose={onCancel}
        >
            <div className="px-4 pt-4 pb-2 sm:px-6 sm:pt-6">
                {title && (
                    <h2
                        className="
                            mb-2
                            text-lg
                            font-bold
                            text-text-primary
                        "
                    >
                        {title}
                    </h2>
                )}
                <p className="text-sm text-text-secondary">{message}</p>
            </div>
            <div
                className="
                    flex
                    flex-col-reverse
                    gap-3
                    border-t
                    border-gray-100
                    px-4
                    py-3
                    sm:flex-row
                    sm:items-center
                    sm:justify-end
                    sm:px-6
                    sm:py-4
                "
            >
                <Button
                    disabled={isPending}
                    variant={ButtonVariantEnum.GHOST}
                    onClick={onCancel}
                >
                    {cancelLabel}
                </Button>
                <Button
                    disabled={isPending}
                    isLoading={isPending}
                    variant={confirmVariant}
                    onClick={onConfirm}
                >
                    {confirmLabel}
                </Button>
            </div>
        </Modal>
    );
};
